import AirDatepicker, {
  type AirDatepickerLocale,
  type AirDatepickerPosition,
} from 'air-datepicker';
// Date & Locale
import localeEn from 'air-datepicker/locale/en';
import localeId from 'air-datepicker/locale/id';
import localeKo from 'air-datepicker/locale/ko';
import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
// UI Components
import ContainerCard from '@/shared/components/ui/ContainerCard/ContainerCard';
import Filtering from '@/shared/components/ui/Filtering/Filtering';
import GeneralInput from '@/shared/components/ui/GeneralInput/GeneralInput';
import 'air-datepicker/air-datepicker.css';
import IndoorAirLog from '@/domains/log/components/IndoorAirLog/IndoorAirLog';

import OutdoorAirLog from '@/domains/log/components/OutdoorAirLog/OutdoorAirLog';
import { formatDateTime, getLocalISOString } from '@/shared/utils/date';

const PAGE_SIZE = 10;

const buildEnvFilterParams = ({
  sensorType,
  startDate,
  endDate,
  search,
}: {
  sensorType: string;
  startDate?: string;
  endDate?: string;
  search?: string;
}) => {
  const params = new URLSearchParams();
  params.set('sensor_type', sensorType);
  if (startDate) {
    params.set('start_time', getLocalISOString(startDate));
  }
  if (endDate) {
    params.set('end_time', getLocalISOString(endDate));
  }
  if (search !== undefined) {
    params.set('search', search);
  }
  return params.toString();
};

const EnvSensorCollectionData = () => {
  const { i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const [_isResetClicked, setIsResetClicked] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const inputRef = useRef<HTMLInputElement>(null);

  const getYesterdayMidnight = useCallback(() => {
    const date = new Date();
    date.setDate(date.getDate());
    date.setHours(0, 0, 0, 999);
    return date;
  }, []);

  const createDefaultRange = useCallback(() => {
    const now = new Date();
    const start = getYesterdayMidnight();
    return {
      start_date: formatDateTime(start),
      end_date: formatDateTime(now),
    };
  }, [getYesterdayMidnight]);

  const initialRange = useMemo(
    () => createDefaultRange(),
    [createDefaultRange]
  );

  const [dateTime, setDateTime] = useState(initialRange);
  const [appliedDateTime, setAppliedDateTime] = useState(initialRange);

  const outdoorFilterParams = useMemo(
    () =>
      buildEnvFilterParams({
        sensorType: 'AIR_TP_OUT',
        startDate: appliedDateTime.start_date,
        endDate: appliedDateTime.end_date,
        search: searchQuery,
      }),
    [appliedDateTime.start_date, appliedDateTime.end_date, searchQuery]
  );

  const indoorFilterParams = useMemo(
    () =>
      buildEnvFilterParams({
        sensorType: 'AIR_TP_IN',
        startDate: appliedDateTime.start_date,
        endDate: appliedDateTime.end_date,
        search: searchQuery,
      }),
    [appliedDateTime.start_date, appliedDateTime.end_date, searchQuery]
  );



 useEffect(() => {
    let locale: AirDatepickerLocale = localeKo;
    if (i18n.language === 'eng') locale = localeEn;
    else if (i18n.language === 'ind') locale = localeId;

const today = new Date();

const yesterdayMidnight = getYesterdayMidnight();
// const optionsDate = {
//   autoClose: true,
//   locale: locale,
//   position: 'bottom center' as unknown as AirDatepickerPosition,
//   selectedDates: [yesterdayMidnight],
//   timepicker: true,
//   timeFormat: 'HH:mm',
//   dateFormat: 'yyyy-MM-dd',
//   onSelect: (date: { formattedDate: string | string[]; date: Date | Date[] }) => {
//     setDateTime((prevValues) => ({
//       ...prevValues,
//       start_date: date.formattedDate as string,
//     }));
//   },
// };

const datepicker1 = new AirDatepicker('[name="start_date"]', {
  autoClose: true,
  locale,
  position: 'bottom center' as unknown as AirDatepickerPosition,

  selectedDates: [
    dateTime.start_date
      ? new Date(dateTime.start_date)
      : yesterdayMidnight,
  ],

  timepicker: true,
  timeFormat: 'HH:mm',
  dateFormat: 'yyyy-MM-dd',

  
  maxDate: today,

  onSelect: ({
    formattedDate,
    date,
  }: {
    formattedDate: string | string[];
    date: Date | Date[];
  }) => {
    const selectedStartDate = date as Date;

    setDateTime((prevValues) => ({
      ...prevValues,
      start_date: formattedDate as string,
    }));

    // update END DATE
    datepicker2.update({
      minDate: selectedStartDate,
      maxDate: today,
    });

    // ambil end date sekarang
    const currentEndDate = datepicker2.selectedDates[0];

    // if end date < start date,
    // automatically change it to the start date
    if (
      currentEndDate &&
      currentEndDate < selectedStartDate
    ) {
      datepicker2.selectDate(selectedStartDate);

      setDateTime((prevValues) => ({
        ...prevValues,
        end_date: formattedDate as string,
      }));
    }
  },
});

// END DATE PICKER
const datepicker2 = new AirDatepicker('[name="end_date"]', {
  autoClose: true,
  locale,
  position: 'bottom center' as unknown as AirDatepickerPosition,

  selectedDates: [
    dateTime.end_date
      ? new Date(dateTime.end_date)
      : today,
  ],

  timepicker: true,
  timeFormat: 'HH:mm',
  dateFormat: 'yyyy-MM-dd',

 
  minDate: dateTime.start_date
    ? new Date(dateTime.start_date)
    : yesterdayMidnight,

 
  maxDate: today,

  onSelect: ({
    formattedDate,
  }: {
    formattedDate: string | string[];
    date: Date | Date[];
  }) => {
    setDateTime((prevValues) => ({
      ...prevValues,
      end_date: formattedDate as string,
    }));
  },
});

setIsResetClicked(false);

return () => {
  datepicker1.destroy();
  datepicker2.destroy();
};



// const optionsDateSecond = {
//   autoClose: true,
//   locale: locale,
//   position: 'bottom center' as unknown as AirDatepickerPosition,
//   selectedDates: [today],
//   timepicker: true,
//   timeFormat: 'HH:mm',
//   dateFormat: 'yyyy-MM-dd',
//   onSelect: (date: { formattedDate: string | string[]; date: Date | Date[] }) => {
//     setDateTime((prevValues) => ({
//       ...prevValues,
//       end_date: date.formattedDate as string,
//     }));
//   },
// };

// const datepicker1 = new AirDatepicker('[name="start_date"]', optionsDate);
// const datepicker2 = new AirDatepicker('[name="end_date"]', optionsDateSecond);
// setIsResetClicked(false);

// return () => {
//   datepicker1.destroy();
//   datepicker2.destroy();
// };
  }, [i18n.language, getYesterdayMidnight,]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setDateTime((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleReset = useCallback(() => {
    const nextRange = createDefaultRange();
    setIsResetClicked(true);
    setDateTime(nextRange);
    setAppliedDateTime(nextRange);
    setSearchQuery('');
  }, [createDefaultRange]);

  const handleSearch = useCallback((value = '') => {
    setAppliedDateTime(dateTime);
    setSearchQuery(value);
  }, [dateTime]);

  const tabs = [
    {
      label: '옥외형 대기질',
      content: (
        <OutdoorAirLog
          filterParams={outdoorFilterParams}
          pageSize={PAGE_SIZE}
        />
      ),
    },
    {
      label: '실내형 공기질',
      content: (
        <IndoorAirLog
          filterParams={indoorFilterParams}
          pageSize={PAGE_SIZE}
        />
      ),
    },
  ];

  return (
    <section className="wrap">
      <div className="header-title">
        <h3>로그</h3>
        <h3>&gt;</h3>
        <h3>환경 수집 데이터</h3>
      </div>

      <ContainerCard>
        <Filtering
          placeholder="사이트 / 접근로"
          disableFiltering={true}
          customWidthSelect="w-[30%]"
          onReset={handleReset}
          onSearch={handleSearch}
        >
          <div className="flex flex-row gap-2 items-center w-full">
            <GeneralInput
              isDob={true}
              type="text"
              name={'start_date'}
              onChange={handleInputChange}
              readonly
              value={dateTime.start_date}
            />
            <span>-</span>
            <GeneralInput
              isDob={true}
              type="text"
              name={'end_date'}
              onChange={handleInputChange}
              value={dateTime.end_date}
              readonly
            />
          </div>
        </Filtering>
      </ContainerCard>

      <div className="w-full">
        <div className="flex flex-row gap-4 bg-[#E6E6E6] dark:bg-[#1a2535] rounded-tl-lg rounded-tr-lg">
          {tabs.map((tab, index) => (
            <button
              type="button"
              key={tab.label}
              className={`w-fit py-2 text-center cursor-pointer hover:opacity-80 ${
                activeTab === index
                  ? 'bg-[#FEFEFE] dark:bg-[#1e3043] text-[#135A78] dark:text-[#9cc8dc] font-bold px-4 rounded-tl-lg rounded-tr-lg border-t border-l border-r border-[#E6E6E6] dark:border-[#2b465f] text-[14px]'
                  : 'border-transparent text-[#6A6A6A] dark:text-[#808890] px-4 text-[14px]'
              }`}
              onClick={() => setActiveTab(index)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="bg-[#fff] dark:bg-[#1a2030] p-[20px] border-r border-l border-b border-[#E6E6E6] dark:border-[#2b465f] rounded-bl-[10px] rounded-br-[10px]">
          {tabs[activeTab]?.content}
        </div>
      </div>
    </section>
  );
};

export default EnvSensorCollectionData;
